<template>

  <div v-if="organisation">
    <h1>{{ organisation.code }} - Shifts</h1>
  </div>
  <div v-else>
    Loading...
  </div>

  <div v-if="userShifts">
    <div class="table-responsive">
      <table class="table table-striped table-sm">
        <thead>
        <tr>
          <th scope="col">Crew member</th>
          <th scope="col">Shift</th>
          <th scope="col" class="d-none d-lg-table-cell">Occupation</th>
          <th scope="col" class="d-table-cell d-lg-none">n/N</th>
          <th scope="col" class="d-none d-lg-table-cell">Score</th>
          <th scope="col" class="d-table-cell d-lg-none">$</th>
          <th scope="col" class="d-none d-lg-table-cell">Status</th>
          <th scope="col" class="d-table-cell d-lg-none"><i class="fa-solid fa-circle-half-stroke"></i></th>
          <th scope="col">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="userShift in userShifts" :key="userShift.id">
          <td>
            <router-link type="button" class="btn btn-primary btn-sm"
                         :to="{ name: 'organisation-user',
                         params: { slug: organisation.slug, username: userShift.user.username } }">
              {{ userShift.user.last_name }} {{ userShift.user.first_name }}
              (${{ userShift.user.user_shift_score }}/{{ userShift.user.user_shift_count }}x)
            </router-link>
          </td>
          <td>{{ userShift.shift.event.code }}.{{ userShift.shift.location.code }}.{{ userShift.shift.name }}</td>
          <td>{{ userShift.shift.spots_taken }}/{{ userShift.shift.capacity }}</td>
          <td>{{ userShift.shift.score }}</td>
          <td><span class="d-flex align-items-center"><button class="btn btn-sm">
            <i v-if="userShift.status === 'pending'" class="fa-solid fa-spinner text-danger"></i>
            <i v-if="userShift.status === 'confirmed'" class="fa-regular fa-circle-check text-success"></i>
            <i v-if="userShift.status === 'waiting_list'" class="fa-solid fa-hourglass-half text-warning"></i>
            </button><span class="ms-0 d-none d-lg-table-cell">{{ userShift.status_display }}</span>
            </span>
          </td>
          <td>
            <div class="d-flex flex-row gap-2">
              <!-- Confirm -->
              <button type="button" class="btn btn-sm btn-success"
                      v-if="userShift.status!=='confirmed'"
                      :disabled="userShift.shift.spots_taken >= userShift.shift.capacity"
                      @click="updateUserShiftStatus(userShift.id,'confirmed')">
                <i class="fa-solid fa-square-check"></i>
              </button>
              <!-- To pending -->
              <button type="button" class="btn btn-sm btn-secondary" v-if="userShift.status!=='pending'"
                      @click="updateUserShiftStatus(userShift.id,'pending')"><i class="fa-solid fa-circle-question"></i>
              </button>
              <!-- To waiting list -->
              <button type="button" class="btn btn-sm btn-warning" v-if="userShift.status!=='waiting_list'"
                      @click="updateUserShiftStatus(userShift.id,'waiting_list')"><i
                  class="fa-solid fa-hourglass-half"></i>
              </button>
              <button type="button" class="btn btn-sm btn-danger"
                      @click="deleteUserShift(userShift.id)"><i
                  class="fas fa-trash"></i>
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>


</template>

<script>
import {API_BASE_URL} from "@/config";
import {setUserShiftStatus, deleteUserShift} from "@/utils/userShiftUtils";


export default {
  data() {
    return {
      organisation: null,
      userShifts: null,
    }
  },
  created() {
    this.fetchUserShifts();
  },
  methods: {
    getCsrfToken() {
      return document.cookie.split('; ').find(row => row.startsWith('csrftoken')).split('=')[1];
    },
    async fetchUserShifts() {
      try {
        const response = await fetch(
            `${API_BASE_URL}/organisations/${this.$route.params.slug}/user-shifts`,
            {
              method: 'GET',
              credentials: 'include',
            }
        );
        if (response.status === 403) {
          this.$router.push({name: 'forbidden'});
        } else if (response.status === 404) {
          this.$router.push({name: 'not-found'});
        } else {
          const data = await response.json();
          this.organisation = {id: data.id, name: data.name, code: data.code};
          this.userShifts = data.user_shifts;
          document.title = `${this.organisation.name} - User Shifts Admin`;
        }
      } catch (error) {
        console.error('Error fetching user shifts:', error);
      }
    },
    async updateUserShiftStatus(userShiftId, status) {
      await setUserShiftStatus(userShiftId, status, this.getCsrfToken, this.fetchUserShifts, this.$router)
    },
    async deleteUserShift(userShiftId) {
      const confirmed = window.confirm("Are you sure you want to delete this user shift?");
      if (confirmed) {
        await deleteUserShift(userShiftId, this.getCsrfToken, this.fetchUserShifts, this.$router);
      }
    },

  }
}
</script>